import React from 'react';
import Header from 'components/ui/Header';
import Footer from 'components/ui/Footer';
import Icon from 'components/AppIcon';
import { Link } from 'react-router-dom';

const ConferenceOrganizationServicesPage = () => {
  const conferenceFeatures = [
    {
      icon: 'Award',
      title: 'COPAF 2026',
      description: 'Conférence Officielle sur les Ports Africains et la Formation - Un événement phare réunissant les acteurs majeurs du secteur portuaire africain',
      features: ['Programme stratégique', 'Networking continental', 'Experts internationaux']
    },
    {
      icon: 'Users',
      title: 'Networking Premium',
      description: 'Facilitation de connexions stratégiques entre décideurs, experts et leaders du secteur portuaire et logistique',
      features: ['Rencontres B2B', 'Ateliers collaboratifs', 'Sessions networking']
    },
    {
      icon: 'Presentation',
      title: 'Conférenciers de Renom',
      description: 'Sélection rigoureuse d\'experts internationaux et autorités portuaires pour des interventions à haute valeur ajoutée',
      features: ['Keynote speakers', 'Panels d\'experts', 'Études de cas']
    },
    {
      icon: 'Calendar',
      title: 'Organisation Clé en Main',
      description: 'Gestion complète de A à Z : logistique, thématiques, communication, et expérience participant',
      features: ['Logistique complète', 'Support multilingue', 'Coordination technique']
    }
  ];

  const copafHighlights = [
    {
      icon: 'Globe',
      title: 'Rayonnement Continental',
      description: 'La COPAF 2026 positionnera votre organisation au cœur de l\'écosystème portuaire africain'
    },
    {
      icon: 'TrendingUp',
      title: 'Innovation & Transformation',
      description: 'Focus sur la digitalisation, l\'IA et les nouvelles technologies dans les opérations portuaires'
    },
    {
      icon: 'Target',
      title: 'Excellence Opérationnelle',
      description: 'Partage des meilleures pratiques internationales et stratégies d\'optimisation'
    },
    {
      icon: 'BookOpen',
      title: 'Formation Continue',
      description: 'Ateliers pratiques et certifications pour le développement du capital humain portuaire'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Section 1: Hero/Introduction - COPAF 2026 Focus */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-20 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `
              linear-gradient(rgba(155, 142, 87, 0.3) 1px, transparent 1px),
              linear-gradient(90deg, rgba(155, 142, 87, 0.3) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px'
          }} />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-6">
              <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                <Icon name="Star" size={20} style={{ color: '#9B8E57' }} />
                <span className="text-sm font-semibold" style={{ color: '#9B8E57' }}>
                  Événement Phare 2026
                </span>
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                Organisation de Conférences
              </h1>
              
              <p className="text-xl md:text-2xl font-semibold" style={{ color: '#9B8E57' }}>
                COPAF 2026 - Excellence Événementielle
              </p>
              
              <p className="text-lg text-gray-300 leading-relaxed">
                La Conférence Officielle sur les Ports Africains et la Formation (COPAF 2026) - Rassembler les acteurs 
                portuaires pour façonner l'avenir du secteur. Une plateforme d'échange stratégique réunissant décideurs, 
                experts et leaders africains.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Link 
                  to="/copaf-registration-form"
                  className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
                  style={{ 
                    backgroundColor: '#96121D',
                    boxShadow: '0 4px 14px rgba(150, 18, 29, 0.4)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#7d0f18';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#96121D';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Inscription COPAF 2026
                  <Icon name="ArrowRight" size={20} className="ml-2" />
                </Link>
                
                <Link 
                  to="/contact"
                  className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-lg border-2 transition-all duration-300"
                  style={{ 
                    borderColor: '#9B8E57',
                    color: '#9B8E57'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#9B8E57';
                    e.target.style.color = '#ffffff';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#9B8E57';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Devenir Sponsor
                  <Icon name="Award" size={20} className="ml-2" />
                </Link>
              </div>
            </div>

            {/* Right Content - Stats Cards */}
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(155, 142, 87, 0.2)' }}>
                    <Icon name="Users" size={24} style={{ color: '#9B8E57' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">500+</div>
                <div className="text-gray-300 text-sm">Participants Attendus</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(150, 18, 29, 0.2)' }}>
                    <Icon name="Globe" size={24} style={{ color: '#96121D' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">25+</div>
                <div className="text-gray-300 text-sm">Pays Africains</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(155, 142, 87, 0.2)' }}>
                    <Icon name="Award" size={24} style={{ color: '#9B8E57' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">50+</div>
                <div className="text-gray-300 text-sm">Conférenciers Experts</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(150, 18, 29, 0.2)' }}>
                    <Icon name="Calendar" size={24} style={{ color: '#96121D' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">3 Jours</div>
                <div className="text-gray-300 text-sm">Programme Intensif</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Conference Features */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              L'Excellence Événementielle COPAF 2026
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Une plateforme d'échange stratégique réunissant décideurs portuaires, experts en formation et leaders africains
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {conferenceFeatures?.map((feature, index) => (
              <div 
                key={index}
                className="group bg-gray-50 rounded-2xl p-8 transition-all duration-300 hover:shadow-xl border-2 border-transparent"
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = index % 2 === 0 ? '#96121D' : '#9B8E57';
                  e.currentTarget.style.transform = 'translateY(-8px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'transparent';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div className="flex items-start space-x-4 mb-6">
                  <div 
                    className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:scale-110"
                    style={{ 
                      backgroundColor: index % 2 === 0 ? 'rgba(150, 18, 29, 0.1)' : 'rgba(155, 142, 87, 0.1)'
                    }}
                  >
                    <Icon 
                      name={feature?.icon} 
                      size={32} 
                      style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} 
                    />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">
                      {feature?.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {feature?.description}
                    </p>
                  </div>
                </div>

                <div className="space-y-3">
                  {feature?.features?.map((item, idx) => (
                    <div key={idx} className="flex items-center space-x-3">
                      <Icon 
                        name="CheckCircle" 
                        size={20} 
                        style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} 
                      />
                      <span className="text-gray-700">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section 3: COPAF 2026 Highlights */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Les Piliers de la COPAF 2026
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Quatre axes stratégiques pour transformer l'écosystème portuaire africain
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {copafHighlights?.map((highlight, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-8 text-center transition-all duration-300 hover:shadow-xl"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div 
                  className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
                  style={{ 
                    backgroundColor: index % 2 === 0 ? 'rgba(150, 18, 29, 0.1)' : 'rgba(155, 142, 87, 0.1)'
                  }}
                >
                  <Icon 
                    name={highlight?.icon} 
                    size={36} 
                    style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} 
                  />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {highlight?.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {highlight?.description}
                </p>
              </div>
            ))}
          </div>

          {/* Organization Excellence Section */}
          <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 shadow-lg">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Notre Accompagnement 360°
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                  De la conception à la réalisation, nous orchestrons chaque aspect de votre événement pour garantir 
                  un impact durable et une expérience participant d'exception.
                </p>
                <div className="flex items-start space-x-3 mb-4">
                  <Icon name="CheckCircle" size={24} style={{ color: '#96121D' }} className="flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Conception Stratégique</h4>
                    <p className="text-gray-600">Définition des thématiques et programme personnalisé</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <Icon name="CheckCircle" size={24} style={{ color: '#9B8E57' }} className="flex-shrink-0 mt-1" />
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Excellence Opérationnelle</h4>
                    <p className="text-gray-600">Logistique complète et coordination technique professionnelle</p>
                  </div>
                </div>
              </div>

              <div 
                className="rounded-2xl p-8 text-white"
                style={{ 
                  background: 'linear-gradient(135deg, #96121D 0%, #7d0f18 100%)'
                }}
              >
                <h3 className="text-2xl font-bold mb-4">Garantie d'Excellence</h3>
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <Icon name="Clock" size={24} className="flex-shrink-0 mt-1" />
                    <p>Ponctualité absolue et respect des délais stratégiques</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Icon name="Shield" size={24} className="flex-shrink-0 mt-1" />
                    <p>Qualité garantie pour chaque aspect de l'événement</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Icon name="TrendingUp" size={24} className="flex-shrink-0 mt-1" />
                    <p>Impact mesurable et retour sur investissement maximisé</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Icon name="Users" size={24} className="flex-shrink-0 mt-1" />
                    <p>Networking premium pour connexions stratégiques durables</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: CTA Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `
              linear-gradient(rgba(155, 142, 87, 0.3) 1px, transparent 1px),
              linear-gradient(90deg, rgba(155, 142, 87, 0.3) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px'
          }} />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Créons Ensemble l'Événement qui Transformera Votre Secteur
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Rejoignez les leaders portuaires africains pour la COPAF 2026 - Une conférence qui redéfinira 
              les standards d'excellence
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
              <Icon name="Calendar" size={32} className="mx-auto mb-4" style={{ color: '#9B8E57' }} />
              <h3 className="text-xl font-bold mb-2">Inscription COPAF</h3>
              <p className="text-gray-300 mb-4">Réservez votre place pour 2026</p>
              <Link 
                to="/copaf-registration-form"
                className="inline-flex items-center justify-center text-sm font-semibold hover:underline"
                style={{ color: '#9B8E57' }}
              >
                S'inscrire maintenant <Icon name="ArrowRight" size={16} className="ml-2" />
              </Link>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
              <Icon name="Award" size={32} className="mx-auto mb-4" style={{ color: '#96121D' }} />
              <h3 className="text-xl font-bold mb-2">Opportunités Sponsoring</h3>
              <p className="text-gray-300 mb-4">Renforcez votre visibilité</p>
              <Link 
                to="/contact"
                className="inline-flex items-center justify-center text-sm font-semibold hover:underline"
                style={{ color: '#96121D' }}
              >
                Devenir sponsor <Icon name="ArrowRight" size={16} className="ml-2" />
              </Link>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
              <Icon name="MessageSquare" size={32} className="mx-auto mb-4" style={{ color: '#9B8E57' }} />
              <h3 className="text-xl font-bold mb-2">Consultation Gratuite</h3>
              <p className="text-gray-300 mb-4">Discutons de votre projet</p>
              <Link 
                to="/contact"
                className="inline-flex items-center justify-center text-sm font-semibold hover:underline"
                style={{ color: '#9B8E57' }}
              >
                Prendre contact <Icon name="ArrowRight" size={16} className="ml-2" />
              </Link>
            </div>
          </div>

          <div className="text-center">
            <Link 
              to="/copaf-registration-form"
              className="inline-flex items-center justify-center px-12 py-5 text-xl font-semibold text-white rounded-lg transition-all duration-300 shadow-lg hover:shadow-2xl"
              style={{ 
                backgroundColor: '#96121D',
                boxShadow: '0 4px 14px rgba(150, 18, 29, 0.4)'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#7d0f18';
                e.target.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#96121D';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              Participer à la COPAF 2026
              <Icon name="ArrowRight" size={24} className="ml-3" />
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ConferenceOrganizationServicesPage;